import type { CtSearchProductsFacet, CtRefinementListItem } from '~~/types/productListing/CtSearchProductsResult';

// Highest rating first, like ais-rating-menu. Range facets return every range, including empty ones.
export const mapCtRatingFacetToItems = (
  facet: CtSearchProductsFacet | undefined,
  selectedRating: number | undefined,
): CtRefinementListItem[] => {

  return (facet?.buckets || [])
    .filter(bucket => bucket.count > 0)
    .map((bucket) => {

      // Bucket keys look like "1.0-*".
      const threshold = String(parseFloat(bucket.key));
      const item: CtRefinementListItem = {
        value: threshold,
        label: threshold,
        count: bucket.count,
        isRefined: selectedRating !== undefined && String(selectedRating) === threshold,
      };

      return item;

    })
    .sort((a, b) => Number(b.value) - Number(a.value));

};
